module.exports = __webpack_public_path__ + "img/class-portal-share.9f66be1d.svg";